const Card = {
  baseStyle: {
    p: "22px",
    display: "flex",
    flexDirection: "column",
    backdropFilter: "blur(120px)",
    width: "100%",
    borderRadius: "20px",
    borderWidth:"2px",
    borderColor:"transparent",
    bg:
      // "linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.49) 100%)",
      "linear-gradient(#01021E, #111F3D) padding-box, linear-gradient(to right, #44C0D8, #187BC8,#7366BC,#BB71BF,#F97382,#F7A95E) border-box",
    // backgroundClip: "border-box",
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
